import React, { useEffect, useState } from 'react';
import { Drawer, DrawerProps, Button, Panel, Divider, Timeline, Loader, Stack } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MdOutlineEditCalendar, MdPerson } from 'react-icons/md';
import CreditCardIcon from '@rsuite/icons/legacy/CreditCard';
import PlaneIcon from '@rsuite/icons/legacy/Plane';
import TruckIcon from '@rsuite/icons/legacy/Truck';
import UserIcon from '@rsuite/icons/legacy/User';
import CheckIcon from '@rsuite/icons/legacy/Check';
import { useDispatch } from 'react-redux';
import { fetchUserHistory } from '@/services/balance.service';
import { connect } from 'react-redux'; // Add this import
import moment from 'moment';
import { useAppSelector } from '@/config/hooks';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import {
  LuCalendar,
  LuCalendarCheck2,
  LuCalendarMinus,
  LuCalendarPlus,
  LuCalendarX2
} from 'react-icons/lu';
import { FiUserCheck } from 'react-icons/fi';
import { FaUserCheck } from 'react-icons/fa';
import { FaCalendarDays } from 'react-icons/fa6';
import {
  BiSolidCalendarCheck,
  BiSolidCalendarEdit,
  BiSolidCalendarExclamation,
  BiSolidCalendarMinus,
  BiSolidCalendarPlus,
  BiSolidCalendarX
} from 'react-icons/bi';
import { TiUserOutline } from 'react-icons/ti';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { FcLeave } from 'react-icons/fc';

interface DetailsDrawerViewProps extends DrawerProps {
  selectedUser?: any;
  onClose: () => void;
  userHistoryData?: any[];
}

const DetailsDrawerView = (props: DetailsDrawerViewProps) => {
  const { onClose, selectedUser, ...rest } = props;
  const dispatch = useDispatch();

  console.log('selectedUser', selectedUser);
  const loading = useAppSelector((state: any) => state.balance.loading);

  const history = useAppSelector((state: any) => state.balance.historyData)?.filter(
    item => item.Type == 'REQUEST' && item.Request.name == 'Leave'
  );

  console.log('history', history);

  useEffect(() => {
    if (selectedUser?.idUser?._id) {
      dispatch(fetchUserHistory(selectedUser.idUser._id));
    }
  }, [selectedUser]);

  // useEffect(() => {
  //   if (userHistoryData?.length > 0) {
  //     setLeaveHistory(
  //       userHistoryData.filter(item => item.Type === 'REQUEST' && item.Request?.name === 'Leave')
  //     );
  //   }
  // }, [userHistoryData]);
  const { t } = useTranslation();


  return (
    <Drawer backdrop="static" size="md" placement="right" onClose={onClose} {...rest}>
      <Drawer.Header>
        <Drawer.Title>{`${selectedUser?.idUser?.firstname} ${selectedUser?.idUser?.lastname} `}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="primary">
            {t('Close')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        {loading ? (
          <Stack justifyContent="center">
            <Loader />
          </Stack>
        ) : (
          <Timeline className="custom-timeline" style={{ color: 'var(--rs-gray-700)' }}>
            {history?.map(item => {
              return (
                <Timeline.Item
                  // time={item.updatedAt && format(new Date(item.updatedAt), 'dd-MM-yyyy HH:mm')}
                  dot={
                    // item.TransactionType == 'LEAVE_SUBMISSION' ? (
                    //   <LuCalendarPlus className="rs-icon" />
                    // ) : item.TransactionType == 'LEAVE_CANCELLATION' ? (
                    //   <LuCalendarMinus className="rs-icon" />
                    // ) : item.TransactionType == 'LEAVE_REVIEWING' ? (
                    //   <MdOutlineEditCalendar className="rs-icon" />
                    // ) : item.TransactionType == 'LEAVE_APPROVAL' ? (
                    //   <LuCalendarCheck2 className="rs-icon" />
                    // ) : item.TransactionType == 'LEAVE_REJECTION' ? (
                    //   <LuCalendarX2 className="rs-icon" />
                    // ) : item.TransactionType == 'ADMIN_UPDATE' ? (
                    //   <MdOutlineEditCalendar
                    //     className="rs-icon"
                    //     // style={{ color: 'var(--rs-primary-500)' }}
                    //   />
                    // ) : (
                    //   <LuCalendar className="rs-icon" />
                    // )
                    item.TransactionType == 'LEAVE_SUBMISSION' ? (
                      <BiSolidCalendarPlus
                        className="rs-icon"
                        style={{ background: 'var(--rs-primary-500)', color: '#fff' }}
                      />
                    ) : item.TransactionType == 'LEAVE_CANCELLATION' ? (
                      <BiSolidCalendarMinus
                        className="rs-icon"
                        style={{ background: 'var(--rs-red-500)', color: '#fff' }}
                      />
                    ) : item.TransactionType == 'LEAVE_REVIEWING' ? (
                      <BiSolidCalendarEdit
                        className="rs-icon"
                        style={{ background: 'var(--rs-primary-500)', color: '#fff' }}
                      />
                    ) : item.TransactionType == 'LEAVE_APPROVAL' ? (
                      <BiSolidCalendarCheck
                        className="rs-icon"
                        style={{ background: 'var(--rs-green-500)', color: '#fff' }}
                      />
                    ) : item.TransactionType == 'LEAVE_REJECTION' ? (
                      <BiSolidCalendarX
                        className="rs-icon"
                        style={{ background: 'var(--rs-red-500)', color: '#fff' }}
                      />
                    ) : item.TransactionType == 'ADMIN_UPDATE' ? (
                      <BiSolidCalendarEdit
                        className="rs-icon"
                        style={{ background: 'var(--rs-primary-500)', color: '#fff' }}
                        // style={{ color: 'var(--rs-primary-500)' }}
                      />
                    ) : (
                      <BiSolidCalendarExclamation
                        className="rs-icon"
                        style={{ background: 'var(--rs-primary-500)', color: '#fff' }}
                      />
                    )
                  }
                  key={item._id}
                >
                  {/* <p>{item.Request?.type}</p> */}

                  <p>{t('Sans solde')}</p>
                  <p>
                    {/* {item.TransactionType != 'ADMIN_UPDATE' ? ( */}
                    <>
                      <Stack spacing={5}>
                        <TiUserOutline />
                        {/* {item.Request?.idReciever?.firstname} {item.Request?.idReciever?.lastname} */}
                        Rawen Mersani
                      </Stack>
                      <Stack spacing={5}>
                        <LuCalendar />
                        17-01-2025 AM {t('To')} 20-01-2025 PM
                        {/* {item.Request?.startDate &&
                          format(new Date(item.Request?.startDate), 'dd-MM-yyyy')}{' '}
                        {item.Request?.startSlot} {' To '}
                        {item.Request?.endDate &&
                          format(new Date(item.Request?.endDate), 'dd-MM-yyyy')}{' '}
                        {item.Request?.endSlot} */}
                      </Stack>
                      {item.isSystemOp == true && <p>System operation</p>}
                    </>
                    {/* ) : (
                      ''
                    )} */}
                  </p>
                  <Stack spacing={5}>
                    <IoSpeedometerOutline />
                    <p>
                      {t('New Balance :')} <b>{item.Request?.NewLeaveBalance}</b>
                    </p>
                  </Stack>
                  <p>{item?.comment}</p>
                  <p>
                    {t('Updated')}:{' '}
                    {item.updatedAt && format(new Date(item.updatedAt), 'dd-MM-yyyy HH:mm')}
                  </p>

                  <div className="footer-right">
                    {item.TransactionType == 'LEAVE_CANCELLATION' ? (
                      <p style={{ color: 'red' }}>{t('Cancellation')}</p>
                    ) : item.TransactionType == 'LEAVE_SUBMISSION' ? (
                      <p style={{ color: 'orange' }}>{t('Submission')}</p>
                    ) : item.TransactionType == 'LEAVE_REVIEWING' ? (
                      <p style={{ color: 'orange' }}>{t('Edition')}</p>
                    ) : item.TransactionType == 'LEAVE_APPROVAL' ? (
                      <p style={{ color: 'green' }}>{t('Approval')}</p>
                    ) : item.TransactionType == 'LEAVE_REJECTION' ? (
                      <p style={{ color: 'red' }}>{t('Rejection')}</p>
                    ) : item.TransactionType == 'ADMIN_UPDATE' ? (
                      <p style={{ color: 'orange' }}>{t('Admin Edition')}</p>
                    ) : (
                      ''
                    )}
                    <div className="content_timeline">
                      <p>{item.Request?.oldLeaveBalance} </p>
                      {Math.sign(item.Request?.NewLeaveBalance - item.Request?.oldLeaveBalance) ==
                      -1 ? (
                        <p className="pl-2">
                          {' '}
                          ({item.Request?.NewLeaveBalance - item.Request?.oldLeaveBalance}){' '}
                        </p>
                      ) : (
                        <p className="pl-2">
                          {' '}
                          (+{item.Request?.NewLeaveBalance - item.Request?.oldLeaveBalance}){' '}
                        </p>
                      )}
                    </div>
                  </div>
                </Timeline.Item>
              );
            })}
          </Timeline>
        )}
      </Drawer.Body>
    </Drawer>
  );
};

export default DetailsDrawerView;
